const fileName = js_params.countryCode.toLowerCase() || 'se';
export const holidayData = (await import(`./data/${fileName}.js`)).holidayData;